import React, {cloneElement, useContext, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {ApplicableTableSettings, infoAreaBicTable, TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, {
  DataFetchResult,
  ExportRowRenderer,
  ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";

import lockBlue from '../../../img/lock_blue.png';
import lockRed from '../../../img/lock_red.png';

import constants from '../../../constants';
import {FilterStorageVersion, Search} from "../../../filtering";

import {NavigationType, openNewPage} from '../../../util/navigationHelpers';

import {
  DateRenderer,DateTimeRenderer,NullableCheckboxIconRenderer,TextAlignLeftRenderer,TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import UniqueLinkButton from '../../../uiControls/UniqueLinkButton';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faCalculator, faCopy, faFileAlt, faPencilAlt, faPlus, faTrashAlt, } from '@fortawesome/free-solid-svg-icons';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import ApplicationContext from '../../../ApplicationContext';
import JobListViewContext, { RightClickContext } from '../../common/JobListViewContext';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import {ActionButtonItem, borderColors, splitMenuItemsIntoSections} from '../../../ui/ActionButton';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import PrimaryButton from '../../../ui/PrimaryButton';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import {JobNames} from "../../../framework.core/JobNames";
import {brokerageTruckingLoadPlanList} from "../tableSettings";
import IfmsModal from "../../../ui/IfmsModal";
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import { BillInvoiceCrdbFilterRenderer, RecognizedFilterRenderer, RecognizedRenderer } from '../../common/commonListRenderers';
import * as XCol from '../../../framework.core/XExportColumn';
import { FmsSubMenu } from '../../../constants/fmsSubMenu';
import { getSelectedSubMenuArgs } from '../../JobListSubMenu';
import useReportViewer from '../../../hooks/useReportViewer';
import postal from 'postal';
import { FmsSecTask, ListFilterType } from '../../../fms.core/constants';
import { getFmsGlobal } from '../../../globals';
import { findSecurityTask } from '../../../util';
import { useJournal } from '../../accounting/general/journal/JournalListView';
import useSuntekSettings from '../../../hooks/useSuntekSettings';
import { BTLoadPlanListItem } from '../../../fms.data/models/BTLoadPlanListItem';
import SmartTable from '../../../uiControls/SmartTable';
import Select from '../../../ui/Select';
import DeleteHistory from '../../reports/DeleteHistory';
import JobListSuntekCommand from '../../common/JobListSuntekCommand';
import { useTypedFastStorage } from '../../../hooks/useFastStorage';
import fastStorage from '../../../fastStorage';
import _ from 'lodash';
import useSetEditedId from '../../../hooks/useSetEditedId';
import { SystemSettings } from '../../../ifmsTypes';
import RecogModal from '../../../ui/RecogModal';
import { nullableCheckBoxValue } from '../../common/commonExportFormat';
import PrimaryInverseButton from '../../../ui/PrimaryInverseButton';
import { useAppSelector } from '../../../app/hooks';

function IndicatorRenderer({ data, row }: any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';
  else if (lStatus === 'OC') dataTooltip = 'OP Close';

  let content: React.ReactNode = <></>;
  if (lStatus === 'PC')
    content = <img height="7px" src={lockRed} id={'redIcon'} style={{ position: 'relative', top: '0px' }} alt="" />;
  else if (lStatus === 'OC')
    content = <img height="7px" src={lockBlue} id={'blueIcon'} style={{ position: 'relative', top: '0px' }} alt="" />;
  return (
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

function LoadStatusRenderer({ data, row }: any) {
  const l = data[row.index];
  let color = 'black';
  const lStatus = (l as any).loadStatus as string;
  if (lStatus === 'Completed') color = 'blue';
  else if (lStatus === 'Delivered') color = 'green';
  else if (lStatus === 'In-Transit') color = 'magenta';
  else if (lStatus === 'Dispatched') color = 'red';

  return (
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} style={{ width: '100%', color }}>{lStatus}</div>
  );
}

function OrderNoRenderer({cell,row,data}: any){
  const {switchToOrderDetail} = useLoadPlanOperations();
  const l = data[row.index];
 if(!cell.value || l.orderCnt > 1){
     return <div className="ifms-table-default">{cell.value}</div>;
  }
 
   return <PrimaryInverseButton onClick={() => switchToOrderDetail(data[row.index])} style={{width: '100%', lineHeight:'1em'}}>{cell.value}</PrimaryInverseButton>
}

function useLoadPlanOperations(){
  const history = useHistory();
  function switchToOrderDetail(load: BTLoadPlanListItem|null){
    if(!load){
      return;
    }
    openNewPage(history, `/brokerageTrucking/order/view/${load.orderId}`, NavigationType.newPage );
  }

  return {switchToOrderDetail}
}


function useSelectedOperations() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory();

  const selectedElement = jobListContext.selectedElement as BTLoadPlanListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  const setBTOSavedEntity = useSetEditedId([JobNames.BTOrder]);

  async function create() {
    if (jobListContext.hasOpenedScreenStartingWithUrl('/brokerageTrucking/loadPlan/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    openNewPage(history, '/brokerageTrucking/loadPlan/add', NavigationType.newPage);
  }

  async function deleteItem() {
    if (!selectedElement) {
      await showGlobalOkDialog('Cannot delete!',false,null,'warning');
      return;
    }

    if(
      jobListContext.hasOpenedScreenStartingWithUrl(`/brokerageTrucking/loadPlan/edit/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenStartingWithUrl(`/brokerageTrucking/loadPlan/view/${selectedElement.id}`) 
    ){
      await showGlobalOkDialog('Need to close Load first', false, null, "warning");
      return;
    }

    if (
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/view/BTLP/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/edit/BTLP/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/view/BTLP/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/edit/BTLP/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close Bill/Invoice first.', false, null, "warning");
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Confirm to Delete?</h3>
      </div>
    ,false,1,true,'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.BTLoadPlan, { id:selectedElement.id });
      if (apiResult && apiResult.success) {
        jobListContext.reloadData();
        setBTOSavedEntity('0', false, false, true);   // BT Order List > Load No 반영
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message,false,null,'warning');
      }
    }
  }

  async function viewBillings() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;

    const viewUrl = `/brokerageTrucking/viewBillings/loadPlan/${id}`;

    if (jobListContext.hasOpenedScreenStartingWithUrl(viewUrl)) {
      await showGlobalOkDialog(<p>View operation is already in progress.</p>);
      return;
    }

    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function viewProfit(viewEdit:boolean) {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;

    const editUrl  = `/brokerageTrucking/loadPlan/edit/${id}`;
    const viewUrl = `/brokerageTrucking/loadPlan/view/${id}`;
    
    //let url = `/brokerageTrucking/loadPlan/${viewEdit ? 'edit' : 'view'}/${id}`;
    let editUrlProfitTab = `${editUrl}/2`;
    let viewUrlProfitTab = `${viewUrl}/2`;

  if (viewEdit && jobListContext.hasOpenedScreenStartingWithUrlWithoutMe(`/brokerageTrucking/loadPlan/edit`, editUrl)) {
      await showGlobalOkDialog(<p>Edit operation is already in progress</p>);
      return;
    }
    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewEdit ? editUrlProfitTab : viewUrlProfitTab, [viewUrl, editUrl]);
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/brokerageTrucking/loadPlan/edit/${id}`;
    const viewUrl = `/brokerageTrucking/loadPlan/view/${id}`;

    // if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe('/brokerageTrucking/loadPlan/edit', editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress.</p>);
    //   return;
    // }
    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/brokerageTrucking/loadPlan/edit/${id}`;
    const viewUrl = `/brokerageTrucking/loadPlan/view/${id}`;
    const listSec = findSecurityTask(appContext, FmsSecTask.BTLoadPlan);
    const urls = [viewUrl];
    if(listSec?.grantEdit) urls.push(editUrl);
    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl('/brokerageTrucking/loadPlan/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    const id = selectedElement.id;
    openNewPage(history, `/brokerageTrucking/loadPlan/add?copyId=${id}`, NavigationType.newPage);
  }

  function switchToOrder() {
    if(!selectedElement) return;
    const url = `/common/joblistview/btOrder/order`;
    jobListContext.setFilterForScreenExternally(url, 'loadNo', 'Load #', selectedElement.loadNo, 'update', false, true, null, 'loadNo', selectedElement.loadNo, false, true);
    openNewPage(history, url, NavigationType.newPage);
  }

  async function recognize(isSet: boolean) {
    // if (selectedElement?.recognized !== 'R' && !selectedElement?.completed) {
    //   await showGlobalOkDialog(<p>Cannot recog because Load is not Completed.</p>);
    //   return;
    // }

    jobListContext.setRecogModalData({ isOpen: true, isSet: isSet });
  }

  return {create, deleteItem, edit, view, copy, recognize, viewBillings, viewProfit, switchToOrder};
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, deleteItem, edit, view, copy, recognize, viewBillings, viewProfit, switchToOrder } = useSelectedOperations();
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as BTLoadPlanListItem;
  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const listSec = findSecurityTask(appContext, FmsSecTask.BTLoadPlan);

  async function processFileLock() {
    const fileLockResult = await appContext.api.opClose(JobNames.BTLoadPlan, selectedElement.id, !selectedElement.isClosed);
    if (!!fileLockResult) {
      await showGlobalOkDialog(fileLockResult, false, null, 'warning');
      return;
    }

    if (selectedElement.isClosed && jobListContext.hasOpenedScreenStartingWithUrl(`/brokerageTrucking/loadPlan/edit/${selectedElement.id}`)) {
      const editModelKey = `editBTLoadPlan${selectedElement.id}-/brokerageTrucking/loadPlan/edit`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      if (keyMatch) {
        fastStorage[keyMatch].fileClosed = 0;
        fastStorage[keyMatch].isClosed = false;
        fastStorage[keyMatch].closedBy = '';
        fastStorage[keyMatch].closeDate = null;
      }
    }

    jobListContext.reloadData();
  }

  let showFileLock = (!selectedElement?.isClosed ? getFmsGlobal().CanFileLock : getFmsGlobal().CanFileUnlock);
  const lockCancelRecog = selectedElement?.recognized === 'R' && (selectedElement?.status === 'PC' || selectedElement?.status === 'OC');

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel },
    { label: 'Go to Manifest List', shortcut: 'F4', separator: false },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: 'Memo', shortcut: 'F8', separator: true, newCol: true },
    { label: 'Copy', shortcut: 'Ctrl+F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'Bilings', shortcut: 'F7', separator: !listSec?.grantEdit },
    { label: 'Profit', shortcut: 'Ctrl+F7', separator: true, hidden: !listSec?.grantEdit },
    { label: !selectedElement?.isClosed ? 'OP Close' : 'OP Open', shortcut: '', separator: false, hidden: !showFileLock || selectedElement?.draft },
    { label: selectedElement?.recognized !== 'R' ? 'Recog' : 'Undo Recog', shortcut: '', separator: false, disabled : lockCancelRecog, hidden: !getFmsGlobal().CanFinalize },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem  name="btload-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    disabled: i?.disabled ?? false,
    hidden: i?.hidden ?? false,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteItem();
        break;
      case 4:
        switchToOrder();
        break;
      case 5:
        jobListContext.triggerTableSearch('F5');
        break;
      case 6:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 7:
        copy();
        break;
      case 8:
        viewBillings();
        break;
      case 9:
        viewProfit(listSec?.grantEdit ? true : false);
        break;
      case 10:
        processFileLock();
        break;
      case 11:
        recognize(selectedElement?.recognized !== 'R');
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
    />
  );
}

function AfterMemoLogButtonCommands() {
  const jobListContext = useContext(JobListViewContext);
  const storage = useAppSelector(x => x.storage);
  const [listFilter, setListFilter, ] = useTypedFastStorage<number>('BTLoadPlan-ListFilter', 0);

  useEffect(() => {
    changeJournalListData(listFilter || 0);
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [listFilter]);

  function changeJournalListData(listFilter : number){
    let listFilterType = ListFilterType.All;
    
    switch(listFilter) {
      case 0: 
        listFilterType = ListFilterType.All;
        break;
      case 1: 
        listFilterType = ListFilterType.NotClosed;
        break;
      case 2: 
        listFilterType = ListFilterType.NotDeparted;
        break;
      case 3: 
        listFilterType = ListFilterType.NotArrived;
        break;
      case 4: 
        listFilterType = ListFilterType.Closed;
        break;
      case 5: 
        listFilterType = ListFilterType.Completed;
        break;
      case 6: 
        listFilterType = ListFilterType.NotCompleted;
        break;
      case 7: 
        listFilterType = ListFilterType.Dispatched;
        break;
      case 8: 
        listFilterType = ListFilterType.InTransit;
        break;
      case 9: 
        listFilterType = ListFilterType.Delivered;
        break;
    }
    
    jobListContext.setListFilterType(listFilterType);
  }

  const filterType =[
    {label: 'All', value: 0},
    {label: 'Dispatched', value: 7},
    {label: 'In-Transit', value: 8},
    {label: 'Delivered', value: 9},
    {label: 'Completed', value: 5},
    {label: 'Closed', value: 4},
    {label: 'Not Departed', value: 2},
    {label: 'Not Arrived', value: 3},
    {label: 'Not Completed', value: 6},
    {label: 'Not Closed', value: 1},
  ]

  return (
    <div style={{marginLeft:'10px', width:'180px', lineHeight:'14px'}}>
        <Select
        placeholder="Filter"
        value={listFilter || 0}
        onChange={e => {setListFilter(Number(e.target.value))}}
        items={filterType}
        maxHeight='225px'
      />
    </div>
  )
}

function TrancationImpactButtonCommands() {
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as BTLoadPlanListItem;
  const {switchJournal} = useJournal();
  const suntekSettings = useSuntekSettings();
  
  // if (!suntekSettings.accounting?.allowTransactionImpact) {
  //   return null;
  // }

  return (
    <PrimaryButton
      size="regular"
      onClick={()=> switchJournal(JobNames.BTLoadPlan, selectedElement.id)}>
      Journal
    </PrimaryButton>
  );
}

function ListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);
  
  const selectedElement = jobListContext.selectedElement as BTLoadPlanListItem;

  const {deleteItem, edit, view, copy, viewBillings} = useSelectedOperations();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const appContext = useContext(ApplicationContext);
  const { viewReport } = useReportViewer();
  const setSavedEntityAfterRecog = useSetEditedId([JobNames.BTOrder, JobNames.SlipJournal]);

  function hasOpenedViewOrEditFor(id: number) {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/brokerageTrucking/loadPlan/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/brokerageTrucking/loadPlan/view/${id}`);
  }

  function doAfterRecog(){
    jobListContext.reloadData();
    setSavedEntityAfterRecog('0', false, false, true);
  }

  const onRecogModalClose = () => {
    jobListContext.setRecogModalData({ isOpen: false, isSet: false });
  }

  function hasOpenedNew() {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/brokerageTrucking/loadPlan/add`);
  }

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  async function onSubMenuClick(fmsSubMenu: FmsSubMenu) {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }
    
    const args = await getSelectedSubMenuArgs(fmsSubMenu, JobNames.BTLoadPlan, selectedElement, appContext, showGlobalYesNoDialog, showGlobalOkDialog);
    if(args){
      viewReport(args, "", true);
    }
  }
  const listSec = findSecurityTask(appContext, FmsSecTask.BTLoadPlan);

  const hasSelectedRow = !!selectedElement;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
  const canBeCopied = hasSelectedRow && !hasOpenedNew() && listSec?.grantAdd;
  const canBeAdd = !hasOpenedNew() && listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;

  return (
    <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
      <div className="ifms-common-no-vertical-separator">
        <UniqueLinkButton name='btload-list-add-button' display="primary" size="regular" link="/brokerageTrucking/loadPlan/add" disabled={!canBeAdd}
                          label="New"/>&nbsp;
        <PrimaryButton name='btload-list-view-button' size="regular" disabled={!hasSelectedRow} onClick={view}>View</PrimaryButton>&nbsp;
        <PrimaryButton name='btload-list-edit-button' size="regular" disabled={!canBeEdit} onClick={edit}>Edit</PrimaryButton>&nbsp;
        <PrimaryButton name='btload-list-delete-button' size="regular" disabled={!canBeDeleted} onClick={deleteItem}>Delete</PrimaryButton>&nbsp;
        <PrimaryButton name='btload-list-copy-button' size="regular" disabled={!canBeCopied} onClick={copy}>Copy</PrimaryButton>
      </div>
      <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
        <PrimaryButton size="regular" onClick={viewBillings}>Billings</PrimaryButton>&nbsp;
        {appContext.user?.isSuntekAdmin && <PrimaryButton size="regular" onClick={() => setSelectedPopupMenuItem({label: 'Delete History (Load)', popupWidth: 1120, popupComponent: <DeleteHistory jobName={JobNames.BTLoadPlan} /> })}>Delete History</PrimaryButton>}
      </div>
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, {onPopupClose})}
        </IfmsModal>
      ) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.subMenu ? onSubMenuClick(selectedPopupMenuItem.subMenu) : null}
      {jobListContext.recogModalData?.isOpen ? (
        <RecogModal reloadData={doAfterRecog} onCancel={onRecogModalClose} mTbId={selectedElement.id} mTbName={"T_BTLOAD"} isSet={jobListContext.recogModalData?.isSet} ></RecogModal>
      ) : null}
    </div>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function ListViewExtras({
}: any,
) {
  useFunctionKeys({onFunction: onFunctionKey});

  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const listSec = findSecurityTask(appContext, FmsSecTask.BTLoadPlan);

  const {copy, create, edit, view, viewBillings, viewProfit, switchToOrder} = useSelectedOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "CTRL+F2") {
      if(listSec?.grantAdd)
        copy();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if(unprocessedFkey === "F4") {
      switchToOrder();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');
    } else if (unprocessedFkey === "F7") {
      viewBillings();
    } else if (unprocessedFkey === "CTRL+F7") {
      viewProfit(listSec?.grantEdit ? true : false);
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F2', 'CTRL+F2', 'F3', 'F4', 'F9', 'F11', 'F8', 'F7', 'CTRL+F7'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  async function loadInfoAreaInvoiceBillCrDb(id: string) {
    const apiResult = await appContext.api.getOceanImportMblInfoAreaBics(id);
    if (!apiResult) {
      return null;
    }

    const tableOptions: ApplicableTableSettings = {
      tableName: 'infoAreaBicTable',
      ...infoAreaBicTable,
      data: apiResult,
      showNewRowPlaceholder: false,
      rowRenderers: [
        {accessor: 'date', Cell: TextRenderer},
        {accessor: 'category', Cell: TextRenderer},
        // @ts-ignore:next-line
        {accessor: 'number', Cell: AccountingEntityRenderer.bind(this, onLinkToAccounting)},
        {accessor: 'companyName', Cell: TextAlignLeftRenderer},
        {accessor: 'cur', Cell: TextRenderer},
        // @ts-ignore:next-line
        {accessor: 'amount', Cell: ({cell}) => CurrencyRenderer(cell.row.values.amount, cell.row.values.cur)},
        // @ts-ignore:next-line
        {accessor: 'paidAmount', Cell: ({cell}) => CurrencyRenderer(cell.row.values.paidAmount, cell.row.values.cur)},
        // @ts-ignore:next-line
        {accessor: 'balance', Header: () => <div style={{marginRight: '8px'}}>Balance</div>, Cell: ({cell}) => CurrencyRenderer(cell.row.values.balance, cell.row.values.cur, true)},
      ],
    };

    return (
      <div style={{width: `${infoAreaBicTable.width}`, marginLeft: 'auto', marginRight: 'auto'}}>
        <SmartTable {...tableOptions} />
      </div>
    );
  }
  
  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.BTLoadPlan}
      jobId={(jobListContext.selectedElement as BTLoadPlanListItem | null)?.id ?? 0}
      customTabs={[
        {
          headline: 'Billings Info',
          contentLoader: loadInfoAreaInvoiceBillCrDb,
        },
      ]}
      onClose={() => jobListContext.setInfoAreaContent('none')}
    />
  );
}

function formatData(data:Array<BTLoadPlanListItem>) {
  return data.map(d => ({
    ...d,
  }));
}

/**
 * Concrete implementation for Other Shipment List screen
 *
 * @class ListView
 * @extends {AbstractListView}
 */
class ListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.BTLoadPlan,
      'BTLoadPlanListItem',
      BTLoadPlanListItem.calculateSearchParameters(search, BTLoadPlanListItem.MapSearchFields),
      1,
      search.pageSize,
      );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return {data: formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [ 
      {
        accessor: 'invStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'billStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'recognized',
        renderer: RecognizedFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(opType:string, systemSettings:SystemSettings): ListRowRenderer[] {
    const useBranch = systemSettings?.enableBranch ?? false;
    return BTLoadPlanListItem.getExportCollection(useBranch).map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if (x.dataIndex === "status") colRenderer.Cell = IndicatorRenderer;
      else if (x.dataIndex === "loadStatus") colRenderer.Cell = LoadStatusRenderer;
      else if (x.dataIndex === "orderNo") colRenderer.Cell = OrderNoRenderer;
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if (x.dataIndex === "recognized") colRenderer.Cell = RecognizedRenderer;
      return colRenderer;
    });
  }

  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({ accessor: 'status', changedValue: (value: any) => { return value['status'] === 'PC' ? 'Period Close' : '' } });
    colRenderer.push({ accessor: 'draft', changedValue: (value: any) => { return nullableCheckBoxValue(value['draft']) } });
    // colRenderer.push({ accessor: 'completed', changedValue: (value: any) => { return nullableCheckBoxValue(value['completed']) } });
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'u2Date',
      orderByAscending: false,
    };
  }

  getTableSettings(opType:string, systemSettings:SystemSettings): TableSettings {
    const tsettings =  brokerageTruckingLoadPlanList;
    const useBranch = systemSettings?.enableBranch ?? false;
    const cols = BTLoadPlanListItem.getExportCollection(useBranch);
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }

  renderExtras() {
    return <ListViewExtras/>
  }

  getViewUrlFor(row: BTLoadPlanListItem) {
    return row && row.id ? `/brokerageTrucking/loadPlan/view/${row.id}` : '';
  }

  getListViewTitle() {
    return 'Load List';
  };

  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.BTLoadPlan} keyProp='id' showAdjustBalance={false} />;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  commandsAfterMemoLogBtn():React.ReactNode{
    return <AfterMemoLogButtonCommands />
  }

  transactionImpactBtn(): React.ReactNode {
    return <TrancationImpactButtonCommands/>
  }
  
  useLogHistory(): boolean {
    return true;
  }
}

export default ListView;